import Cookies from "js-cookie";

export default new class Csrf {
    public getToken(): string {
        return Cookies.get('XSRF-TOKEN') || '';
    }
}
